export default "__VITE_ASSET__AwQevIbo__"